import { SEO_TITLE_SIGNUP, SIGNUP_CONFIRM_AND_SIGN_UP } from 'mk/autogenerated/translations/SignupPage.2c2b193bf9d09b7f1a53c950aaebc663'
import { ACTIVE_SERVER_ID } from 'mk/settings';
import { analyticsStoreEvent } from 'mk2/actions';
import { UtmQuery } from 'mk2/apps/home/schemas';
import { SignupFormData } from 'mk2/apps/users/components/SignupForm';
import Signup from 'mk2/apps/users/containers/Signup/Signup';
import { signupTrigger, validateRegistrationInputs } from 'mk2/apps/users/containers/Signup/Signup.actions';
import { SIGNUP_FORM_NAME } from 'mk2/apps/users/containers/Signup/Signup.constants';
import signupSaga from 'mk2/apps/users/containers/Signup/Signup.sagas';
import { signupUrl } from 'mk2/apps/users/urls';
import { loginSignupTabs } from 'mk2/apps/users/utils';
import SubmitButton from 'mk2/components/forms/SubmitButton';
import { FormPageType } from 'mk2/constants';
import { abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { AppName } from 'mk2/containers/Application/Application';
import {
    phoneVerificationRequestToken,
    phoneVerificationVerifyToken,
} from 'mk2/containers/PhoneVerification/PhoneVerification.actions';
import { Mode } from 'mk2/containers/PhoneVerification/PhoneVerification.constants';
import { PhotosUploadConfig } from 'mk2/containers/PhotosUpload/PhotosUpload';
import { photosUploadTrigger } from 'mk2/containers/PhotosUpload/PhotosUpload.actions';
import { cachedInitialValues, mkReduxFormMapDispatchToProps, mkReduxFormMapStateToProps } from 'mk2/helpers/form';
import { PhotoUploadStatus, SuccessfulPhotoUpload } from 'mk2/helpers/form.reducers';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import FormPage, { FormPageDispatchProps, FormPageStateProps } from 'mk2/pages/FormPage';
import { AppState, getRequestDeviceMobile, getRequestLastKnownUsername } from 'mk2/reducers';
import { HeaderMenuItem, MenuSelection, PhotoEntity, PhotoSchema } from 'mk2/schemas';
import { getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { formValueSelector, getFormValues } from 'redux-form';

interface OwnProps {}

interface StateProps extends FormPageStateProps {
    query: UtmQuery;
    initialValues: SignupFormData;
    currentValues: SignupFormData;
    mobile: boolean;
    signupVariant: ABState;
    avatar?: PhotoEntity;
}

interface DispatchProps extends FormPageDispatchProps {
    onSignup(values: SignupFormData, query: UtmQuery, iframe: boolean, newSignupForm: boolean);
    onStoreEvent(name: string, props: any);
    onValidateInputs(values: SignupFormData, query: UtmQuery);
    onSendSmsToken(prefix: string, phoneNumber: string, mode: Mode);
    onVerifySmsToken(token: string, mode: Mode, fullPhoneNumber: string);
    onPrepareUploadPhotos(formName: string, config: PhotosUploadConfig, files: File[], processPhotoUploadOnFormPage: FormPageType, accessKey?: string);
    onLoadAB();
}

type RouteProps = RouteComponentProps<{}>;

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class SignupPage extends FormPage<OwnProps & RouteProps, StateProps, DispatchProps> {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const { location } = ownProps;

            const query = parse(location.search);
            const username = query.username
                ? query.username.toLowerCase()
                : getRequestLastKnownUsername(state);

            const selector = formValueSelector(SIGNUP_FORM_NAME);
            const currentPhotos = selector(state, 'photos') as any[] || [];
            const avatar: PhotoEntity =
                (currentPhotos && currentPhotos.length > 0 && currentPhotos[0].status === PhotoUploadStatus.SUCCESS)
                    ? getDenormalizedEntity<PhotoEntity>(state, PhotoSchema, (currentPhotos[0] as SuccessfulPhotoUpload).photoId)
                    : null;

            return {
                ...mkReduxFormMapStateToProps(SIGNUP_FORM_NAME)(state),

                avatar,
                query,
                initialValues: cachedInitialValues(SIGNUP_FORM_NAME, {
                    username: '',
                    password: '',
                    email: '',
                    place: '',
                    locationCounty: '',
                    pregnancyState: '',
                    dueDate: '',
                    prefix: ACTIVE_SERVER_ID === 201 ? '+421' : '+420',
                    phoneNumber: '',
                    token: '',
                    photos: [],
                    currentPhoto: false,
                    visibleFace: false,
                    alonePhoto: false,
                    // avatarCrop: [xPosition, yPosition, width]
                    avatarCrop: [0, 0, 100],
                }, username),
                mobile: getRequestDeviceMobile(state),
                currentValues: getFormValues(SIGNUP_FORM_NAME)(state) as SignupFormData,
                signupVariant: getABVariant(state, 'fixed_signup_versions'),
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            ...mkReduxFormMapDispatchToProps(SIGNUP_FORM_NAME),
            onSignup: signupTrigger,
            onStoreEvent: analyticsStoreEvent,
            onValidateInputs: validateRegistrationInputs,
            onSendSmsToken: phoneVerificationRequestToken,
            onVerifySmsToken: phoneVerificationVerifyToken,
            onPrepareUploadPhotos: photosUploadTrigger,
            onLoadAB: () => abFetch('fixed_signup_versions'),
        };
    }

    public getMetaTitle(props: Props): string {
        return SEO_TITLE_SIGNUP;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <Signup {...props} />
        );
    }

    public hasPageHeaderPart1(props: Props): boolean {
        const { mobile } = props;
        if (mobile) {
            return true;
        }
    }

    public hasHeaderBackButton(props: Props): boolean {
        const { mobile, currentFormPage } = props;
        if (currentFormPage !== FormPageType.Main) {
            return true;
        }
    }

    public getDefaultBackPath(props: Props): string {
        return url(signupUrl, {});
    }

    public getHeaderTabs(props: Props): (JSX.Element[] | null) {
        const { mobile, currentFormPage } = props;
        if (mobile && currentFormPage === FormPageType.Main) {
            return loginSignupTabs('signup');
        }
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: app,
            activeItem: HeaderMenuItem.UserSignup,
        };
    }

    public hasMobileLogo(props: Props): boolean {
        const { avatar } = props;
        if (!avatar) {
            return true;
        }
    }

    public getHeaderLeft(props: Props): React.ReactNode {
        const { mobile } = props;
        return mobile;
    }

    public getHeaderRight(props: Props): React.ReactNode {
        const { currentFormPage, avatar, mobile } = props;
        if (currentFormPage === FormPageType.SignupPhotoUpload && avatar && mobile) {
            return this.getSubmitButton(props);
        }

        return null;
    }

    public getSubmitButton(props: Props): JSX.Element {
        return (
            <SubmitButton
                label={SIGNUP_CONFIRM_AND_SIGN_UP}
                formName={SIGNUP_FORM_NAME}
            />
        );
    }

    public getFooter(props: Props): boolean {
        return null;
    }

    public registerInStore(store: Store<AppState>) {
        // store.injectReducer('containers.users.signup', signupReducer);
        store.injectSaga('containers.users.signup', signupSaga);
    }
}
